/**
 * BaseGameUI
 * Handles UI panels for portrait and landscape view.
 */

export default class BaseGameUI {
    // ==================== Construction ====================
    constructor(game) {
        this.game = game;
        this.view = game.make.group();

        this.buttons = [];
        this.texts = [];

        this.paused = false;
        this.visible = false;
    }

    init(game) {
        this.levelText.text = 'Level ' + game.level;
        this.totalPointsText.text = game.score.toString();
        this.updateBombCounter(game.availableBombs);

        // Reset goals text
        this.currentGoals.text = 'Lines 0/' + game.goal;
        this.goalCompleteMark.alpha = 0;
        this.goals.alpha = 1;
        this.currentGoals.alpha = 1;
        this.bombPanel.alpha = 0;
        this.bombFiller.alpha = 0;
        this.bonusBombText.alpha = 0;

        // this.game.add.tween(this.goalCompletedSign)
        //     .to({y: this.goalCompletedSign.y + 39 / 2 * PARAMS.scaleFactor}, 300, Phaser.Easing.Linear.None, true, 2000);
    }

    // ==================== Button Callbacks ====================
    onButtonExit() {
        if (!this.visible) {
            return;
        }
        ARK_game_arena_connector.fireEventToArena('event_change');
        AUDIO.playSound('buttonClick');
        GS.pause();
        GS.overlayScreens.showScreen('exitGame');
    }

    onButtonHelp() {
        if (!this.visible) {
            return;
        }
        ARK_game_arena_connector.fireEventToArena('event_change');
        AUDIO.playSound('buttonClick');
        GS.pause();
        GS.overlayScreens.screenBeforeHelp = 'game';
        GS.overlayScreens.showScreen('help1');
    }

    onButtonPause() {
        if (!this.visible) {
            return;
        }
        ARK_game_arena_connector.fireEventToArena('event_change');
        AUDIO.playSound('buttonClick');
        GS.pause();
        GS.overlayScreens.showScreen('pause');
    }

    onButtonMute() {
        if (!this.visible) {
            return;
        }
        ARK_game_arena_connector.fireEventToArena('event_change');
        AUDIO.playSound('buttonClick');
        GS.mute();
    }

    onButtonUnmute() {
        if (!this.visible) {
            return;
        }
        ARK_game_arena_connector.fireEventToArena('event_change');
        AUDIO.playSound('buttonClick');
        GS.unmute();
    }

    updateMuteButtons() {
        if (AUDIO.allMuted) {
            this.buttonMute.alpha = 1;
            this.buttonUnmute.alpha = 0;
            this.buttonMute.inputEnabled = true && this.visible && !this.paused;
            this.buttonUnmute.inputEnabled = false;
        }
        else {
            this.buttonMute.alpha = 0;
            this.buttonUnmute.alpha = 1;
            this.buttonMute.inputEnabled = false;
            this.buttonUnmute.inputEnabled = true && this.visible && !this.paused;
        }
    }

    setEnableForAllButtons() {
        var enable = this.visible && !this.paused;
        for (var i = 0; i < this.buttons.length; i++) {
            this.buttons[i].inputEnabled = enable;
        }
        this.updateMuteButtons();
    }

    // ==================== Interface ====================
    show() {
        this.visible = true;
        this.setEnableForAllButtons();
        this.view.alpha = 1;
        GS.view.addAt(this.view, 0);
    }

    hide() {
        this.visible = false;
        this.setEnableForAllButtons();
        this.view.alpha = 0;
        GS.view.removeChild(this.view);
    }

    onPause() {
        this.paused = true;
        this.setEnableForAllButtons();
    }

    onResume() {
        this.paused = false;
        this.setEnableForAllButtons();
    }

    // ==================== Update ====================
    updateBombCounter(bombs) {
        if (bombs === 0) {
            this.bombCounterText.setText('');
            this.bombInstructionText.alpha = 0
        }
        else {
            this.bombCounterText.setText('x ' + bombs);
            this.bombInstructionText.alpha = 1
        }
    }

    updateFiller(factor) {
        var tween = this.game.add.tween(this.bombFiller.cropRect)
            .to({width: factor * this.widthForFullInficator}, 500)
            .start();

        tween.onUpdateCallback(function () {
            this.bombFiller.updateCrop()
        }, this);
    }

    updateGoals(lines, goal) {
        this.currentGoals.setText('Lines ' + lines + '/' + goal)
    }

    updateSelectedWord(word, valid, points) {
        this.wrongText.fontSize = this.currentWordFontSize * PARAMS.scaleFactor;
        this.rightText.fontSize = this.currentWordFontSize * PARAMS.scaleFactor;
        if (valid) {
            this.setValidWord(word);
        }
        else {
            this.setInvalidWord(word);
        }
        if (points >= 0) {
            this.wordPointsText.setText(points);
        }
        else {
            this.wordPointsText.setText('');
        }
    }

    updateTexts(texts) {
        if (!texts) {
            texts = this.texts;
        }

        var globalScale = 1;
        var par = this.view;
        while (par) {
            // par.x = Math.round(par.x);
            // par.y = Math.round(par.y);
            // par.pivot.x = Math.round(par.pivot.x);
            // par.pivot.y = Math.round(par.pivot.y);
            globalScale *= par.scale.x;
            par = par.parent
        }

        for (var i = 0; i < texts.length; i++) {
            var elem = texts[i];
            // elem.x = Math.round(elem.x)
            // elem.y = Math.round(elem.y)
            // elem.pivot.x = Math.round(elem.pivot.x);
            // elem.pivot.y = Math.round(elem.pivot.y);

            if (elem.preferredFontSize) {
                var newFont = PARAMS.getFonts(elem.fontNameColor, globalScale * elem.preferredFontSize);
                elem.font = newFont
            }
            // elem.x -= elem.worldPosition.x - Math.floor(elem.worldPosition.x) ;
            // elem.y -= elem.worldPosition.y - Math.floor(elem.worldPosition.y) ;
        }
    }

    updateTimer(timeLeft) {
        var seconds = Math.round(timeLeft / 1000);
        this.timeLeftText.setText(seconds);
        if (seconds <= 15) {
            this.timeLeftText.tint = 0xff6666;
        }
        else {
            this.timeLeftText.tint = 0xffffff;
        }
        window.timeLeft = this.timeLeftText;
    }

    updateTotalScore(score) {
        this.totalPointsText.setText(score)
    }

    // ==================== Methods ====================
    clearCurrentScore() {
        this.game.time.events.add(500, function () {
            this.wordPointsText.setText('');
            this.setValidWord('');
        }, this)
    }

    goalReached() {
        this.goalCompleteMark.alpha = 1;
        this.goalCompleteMark.play('show');

        this.game.add.tween(this.goals)
            .to({alpha: 0}, 300, Phaser.Easing.Linear.None, true, 1500);

        this.game.add.tween(this.currentGoals)
            .to({alpha: 0}, 300, Phaser.Easing.Linear.None, true, 1500);

        this.game.add.tween(this.goalCompletedSign)
            .to({y: this.goalCompletedSign.y + 39 / 2 * PARAMS.scaleFactor}, 300, Phaser.Easing.Linear.None, true, 2000);

        this.game.add.tween(this.bombPanel)
            .to({alpha: 1}, 300, Phaser.Easing.Linear.None, true, 1750);

        this.game.add.tween(this.bombFiller)
            .to({alpha: 1}, 300, Phaser.Easing.Linear.None, true, 1750);

        this.game.add.tween(this.bonusBombText)
            .to({alpha: 1}, 300, Phaser.Easing.Linear.None, true, 1750);
    }

    // ==================== Helper Methods ====================
    addTextElement(x, y, font, text, size) {
        var element = this.game.make.bitmapText(x * PARAMS.scaleFactor, y * PARAMS.scaleFactor, font, text, size * PARAMS.scaleFactor);
        element.anchor.set(0.5);
        this.view.add(element);
        this.texts.push(element);
        return element;
    }

    addTextElement2(x, y, fontColor, text, size) {
        var font = PARAMS.getFonts(fontColor, size);
        var element = this.game.make.bitmapText(x * PARAMS.scaleFactor, y * PARAMS.scaleFactor, font, text, size * PARAMS.scaleFactor);
        element.preferredFontSize = size * PARAMS.scaleFactor;
        element.fontNameColor = fontColor;
        element.anchor.set(0.5);
        this.view.add(element);
        this.texts.push(element);
        return element;
    }

    addButton(x, y, texture, action) {
        var normal = texture + '.png';
        var down = texture + 'Rollover.png';
        var button = PARAMS.addButton(this.game, x * PARAMS.scaleFactor, y * PARAMS.scaleFactor, 'gameElements', action, this, normal, normal, down);
        button.anchor.set(0.5);
        this.view.add(button);
        this.buttons.push(button);
        return button;
    }

    setInvalidWord(word) {
        word = word.substring(0, 15);
        this.wrongText.alpha = 1;
        this.wrongText.setText(word.toUpperCase());
        this.rightText.alpha = 0;

        var width = this.wrongText.width;
        var change = false;
        if (width > this.currentWordMaxLength * PARAMS.scaleFactor) {
            this.wrongText.fontSize -= 1;
            this.setInvalidWord(word);
            change = true;
        }
        if (change) {
            this.updateTexts();
        }
    }

    setValidWord(word) {
        word = word.substring(0, 15);
        this.wrongText.alpha = 0;
        this.rightText.setText(word.toUpperCase());
        this.rightText.alpha = 1;

        var width = this.rightText.width;
        var change = false;
        if (width > this.currentWordMaxLength * PARAMS.scaleFactor) {
            this.rightText.fontSize -= 1;
            this.setValidWord(word);
            change = true;
        }
        if (change) {
            this.updateTexts();
        }
    }

    // ==================== Destruction ====================
    destroy() {
        this.game = null;
        this.view = null;

        for (var i=0; i<this.buttons.length; ++i) {
            this.buttons[i].destroy();
        }
        this.buttons.length = 0;

        for (var i=0; i<this.texts.length; ++i) {
            this.texts[i].destroy();
        }
        this.texts.length = 0;
    }
}
